import {
  QIcon_arrow_down_gray,
  QIcon_arrow_down_red,
  QIcon_arrow_up_gray,
  QIcon_arrow_up_green,
  QIcon_same_gray,
} from '@repo/icons/index'
import { CAF_A_TAG_MAP, CAF_C_TAG_MAP, CAF_F_TAG_MAP, CAF_P_TAG_MAP } from '../../../../../model/caf.interface'
import { ILessonDiff } from '../../../../apis/student/lesson'
import { n_caf } from '../../../../i18n/strings/auto/wording_webview'
import useTranslation from '../../../../i18n/useTranslation'
import { COLORS } from '../../../../vars'

const useCafLessonDiffData = (diffDatas: ILessonDiff[], analysisType: number) => {
  const { t } = useTranslation()
  const type = analysisType === 1 ? 'type_c' : analysisType === 2 ? 'type_a' : analysisType === 3 ? 'type_f' : 'type_p'
  const diffDataAsTag = diffDatas?.find((data) => data.tag === analysisType)
  const isFirst = diffDatas?.length === 0
  if (!diffDataAsTag)
    return {
      isFirst: true,
      Icon: null,
    }
  const { band_diff, is_band_changed, reasoning_data } = diffDataAsTag
  const Icon = (props) => {
    if (is_band_changed) {
      if (band_diff > 0) {
        return <QIcon_arrow_up_green {...props} />
      } else {
        return <QIcon_arrow_down_red {...props} />
      }
    } else {
      if (band_diff === 0) {
        return <QIcon_same_gray {...props} />
      } else if (band_diff > 0) {
        return <QIcon_arrow_up_gray {...props} />
      } else {
        return <QIcon_arrow_down_gray {...props} />
      }
    }
  }
  const getDiffColor = () => {
    if (is_band_changed) {
      if (band_diff > 0) {
        return {
          text: COLORS.GREEN500,
          bg: COLORS.GREEN50,
          border: COLORS.GREEN200,
        }
      } else {
        return {
          text: COLORS.RED500,
          bg: COLORS.RED50,
          border: COLORS.RED200,
        }
      }
    } else {
      return {
        text: COLORS.GRAY700,
        bg: COLORS.GRAY100,
        border: COLORS.GRAY200,
      }
    }
  }

  const getTitle = () => {
    const score = Math.abs(band_diff)
    const name =
      analysisType === 1
        ? 'Complexity'
        : analysisType === 2
        ? 'Accuracy'
        : analysisType === 3
        ? 'Fluency'
        : 'Pronunciation'
    const wording_obj = analysisType !== 4 ? n_caf.diff_title : n_caf.diff_title_p
    if (is_band_changed) {
      if (band_diff > 0) {
        return t(wording_obj.up(name, score))
      } else {
        return t(wording_obj.down(name, score))
      }
    } else {
      if (band_diff === 0) {
        return t(n_caf.diff_title.same(name))
      } else if (band_diff > 0) {
        return t(wording_obj.up_little(name, score))
      } else {
        return t(wording_obj.down(name, score))
      }
    }
  }

  const GroupString = (data: number[], color) => {
    if (!data || data.length === 0) return ''

    const TAG_MAP =
      analysisType === 1
        ? CAF_C_TAG_MAP
        : analysisType === 2
        ? CAF_A_TAG_MAP
        : analysisType === 3
        ? CAF_F_TAG_MAP
        : CAF_P_TAG_MAP
    const wordingObj = n_caf[type]

    return data.length > 0
      ? () => (
          <span style={{ color: color, fontWeight: 'bold' }}>
            {data
              .map((tag, i, arr) => {
                const key = TAG_MAP[tag]
                return t(wordingObj[key])
              })
              .join(', ')}
          </span>
        )
      : null
  }
  const getMainDescription = () => {
    const colors = getDiffColor()
    const MainGroup = GroupString(reasoning_data.main, colors.text)
    const SubGroup = GroupString(reasoning_data.sub, COLORS.GRAY600)
    const mainWordingObj = n_caf[type].main
    const subWordingObj = n_caf[type].sub
    const status = band_diff === 0 ? 'same' : band_diff > 0 ? 'up' : 'down'
    const getMainWordingString = mainWordingObj[status]
    const getSubWordingString = subWordingObj[status]
    if (typeof getMainWordingString !== 'function' || typeof getSubWordingString !== 'function') return ''
    return (
      <>
        {MainGroup && t(getMainWordingString(<MainGroup />))} {SubGroup && t(getSubWordingString(<SubGroup />))}
      </>
    )
  }

  return {
    isFirst,
    Icon,
    diffDataAsTag,
    diffColors: getDiffColor(),
    title: getTitle(),
    description: getMainDescription(),
  }
}

export default useCafLessonDiffData
